/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Target_LabelInputs */

const en_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target folder`)
};

const fr_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dossier cible`)
};

const de_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielordner`)
};

const it_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cartella di destinazione`)
};

const ru_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая папка`)
};

const es_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta de destino`)
};

const zh_cn2_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标文件夹`)
};

const ja_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象フォルダー`)
};

const hi_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य फ़ोल्डर`)
};

const pt_pt2_audio_embed_export_target_label = /** @type {(inputs: Audio_Embed_Export_Target_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta de destino`)
};

/**
* | output |
* | --- |
* | "Target folder" |
*
* @param {Audio_Embed_Export_Target_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_target_label = /** @type {((inputs?: Audio_Embed_Export_Target_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Target_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_embed_export_target_label(inputs)
	if (locale === "de") return de_audio_embed_export_target_label(inputs)
	if (locale === "it") return it_audio_embed_export_target_label(inputs)
	if (locale === "ru") return ru_audio_embed_export_target_label(inputs)
	if (locale === "es") return es_audio_embed_export_target_label(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_embed_export_target_label(inputs)
	if (locale === "ja") return ja_audio_embed_export_target_label(inputs)
	if (locale === "hi") return hi_audio_embed_export_target_label(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_embed_export_target_label(inputs)
	return en_audio_embed_export_target_label(inputs)
});